import Container from "@/Components/Grid/Container";
import Column from "@/Components/Grid/Column";
import Row from "@/Components/Grid/Row";
import FrontText from "../../FrontText";
import { Link } from "@inertiajs/react";
import React from "react";
import FrontRoundedButton from "../../Buttons/FrontRoundedButton";

const FrontSimpleHero = ({ heading, description, links }) => {
    links = links.filter((elem) => elem !== false);

    return (
        <Container>
            <Row>
                <Column>
                    <div className="bg-white shadow-gray-box mt-10 lg:py-12 md:py-8 py-6 2xl:px-20 xl:px-16 lg:px-12 sm:px-8 px-6 flex flex-wrap gap-y-10">
                        <div className="md:w-1/2 w-full">
                            <FrontText
                                textSize="32/28-m-28/32"
                                className="text-dark-blue font-bold font-domine mb-4"
                            >
                                {heading}
                            </FrontText>

                            <FrontText
                                textSize="16/20"
                                className="text-dark-blue"
                            >
                                {description}
                            </FrontText>
                        </div>

                        <div className="flex lg:flex-row md:flex-col sm:flex-row flex-col items-center lg:justify-end justify-center md:w-1/2 w-full lg:pl-5">
                            {links.map((el, index) => (
                                <React.Fragment key={el.title + "-" + index}>
                                    <Link href={el.href} title={el.title} className="text-dark-blue font-medium hover:text-yellow transition-all ease-in-out duration-200 mb-3 sm:mb-0">
                                        {/* <FrontRoundedButton className="mx-auto">
                                            {el.title}
                                        </FrontRoundedButton> */}
                                        <FrontText
                                            textSize="16/20"
                                            className="flex stroke-blue-classic items-center hover:stroke-yellow transition-all ease-in-out duration-200"
                                        >
                                            {el.title}
                                            <svg
                                                width="14"
                                                height="14"
                                                viewBox="0 0 14 18"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="ml-3"
                                            >
                                                <path
                                                    d="M2 1.5L11 8.31818L2 16.5"
                                                    strokeWidth="3"
                                                />
                                            </svg>
                                        </FrontText>
                                    </Link>
                                    {index + 1 != links.length && (
                                        <span className="h-[14px] w-[14px] mx-7 bg-yellow  rounded-full shrink-0 lg:my-0 md:my-3 sm:my-0 my-3 hidden sm:block"></span>
                                        // <span className="h-[14px] w-[14px] mx-7 bg-yellow rounded-full shrink-0 lg:my-0 md:my-3 sm:my-0 my-3"></span>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </Column>
            </Row>
        </Container>
    );
};

export default FrontSimpleHero;
